import mark from "@/assets/welock-mark.png";

// Official welock interlock mark.
export function WelockMark({ size = 28, className = "" }) {
  return (
    <img
      src={mark}
      alt="welock"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: "contain", display: "block" }}
    />
  );
}

export function WelockLogo({ className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <WelockMark size={26} />
      <span className="font-heading text-lg font-semibold tracking-tight text-welock-textPrimary">
        welock
      </span>
    </div>
  );
}
